// Contenu de la page « Plan de table mariage en ligne gratuit » (référencement).
// En français uniquement : la page vise les recherches Google françaises.

export const STEPS = [
  {
    title: 'Posez vos tables',
    text: 'Tables rondes ou rectangulaires, de 2 à 24 places, avec le nom de votre choix. Déplacez-les et faites-les pivoter pour reproduire votre salle.',
  },
  {
    title: 'Glissez vos invités',
    text: 'Vos invités attendent dans la liste « À placer ». Glissez-les sur une place, ou sur téléphone, touchez un invité puis une place libre.',
  },
  {
    title: 'Transmettez au traiteur',
    text: 'La vue traiteur montre le menu de chaque convive, les enfants et les allergies, table par table. Imprimez, c’est prêt.',
  },
];

export const FEATURES = [
  {
    title: 'Vos invités sont déjà là',
    text: 'Le plan part de votre liste d’invités et des réponses reçues : présents, en attente et absents sont signalés d’un coup d’œil.',
  },
  {
    title: 'Toujours à jour',
    text: 'Un invité change sa réponse ? Le plan le montre aussitôt. Fini les versions d’Excel qui se contredisent.',
  },
  {
    title: 'Un plan par événement',
    text: 'Dîner, brunch du lendemain : chaque moment a son propre plan de table, avec ses propres invités.',
  },
  {
    title: 'La vue traiteur',
    text: 'Menus, enfants, allergies et notes pour le traiteur apparaissent sur chaque place. Plus besoin de tout recopier.',
  },
  {
    title: 'Prêt à imprimer',
    text: 'Imprimez le plan de la salle et la liste des convives table par table, pour le traiteur, le lieu ou l’entrée de la salle.',
  },
  {
    title: 'Gratuit, à deux',
    text: 'Aucun abonnement, aucune carte bancaire. Vous construisez le plan ensemble, depuis l’ordinateur ou le téléphone.',
  },
];

// Places conseillées selon la taille de la table (ordre de grandeur des loueurs)
export const TABLE_SIZES = [
  { table: 'Ronde, Ø 120 cm', guests: '6 personnes (8 en se serrant)' },
  { table: 'Ronde, Ø 150 cm', guests: '8 personnes (10 en se serrant)' },
  { table: 'Ronde, Ø 180 cm', guests: '10 à 12 personnes' },
  { table: 'Rectangulaire, 180 × 80 cm', guests: '6 à 8 personnes' },
  { table: 'Rectangulaire, 240 × 80 cm', guests: '8 à 10 personnes' },
];

export const TIPS = [
  {
    title: 'Attendez les dernières réponses',
    text: 'Commencez dès que la majorité des invités a répondu, mais ne figez le plan que deux à trois semaines avant le mariage.',
  },
  {
    title: 'Décidez de la table d’honneur',
    text: 'Avec les témoins, avec les parents, ou une table pour deux : choisissez d’abord, le reste du plan en découle.',
  },
  {
    title: 'Placez d’abord les familles',
    text: 'Parents, grands-parents, frères et sœurs près des mariés. Ce sont les placements les plus attendus.',
  },
  {
    title: 'Regroupez par affinités',
    text: 'Amis de fac, collègues, cousins : des tables où chacun connaît au moins deux ou trois personnes.',
  },
  {
    title: 'Pensez aux enfants',
    text: 'Une table des enfants près de celle de leurs parents, ou les plus petits à côté d’eux. Signalez-les au traiteur pour le menu.',
  },
  {
    title: 'Protégez les oreilles sensibles',
    text: 'Les plus âgés loin des enceintes et de la piste de danse, près de la sortie et des toilettes.',
  },
  {
    title: 'Désamorcez les tensions',
    text: 'Deux personnes en froid ? Placez-les à des tables éloignées, sans les isoler pour autant.',
  },
  {
    title: 'Donnez des noms aux tables',
    text: 'Fleurs, vins, villes de votre histoire : des noms plutôt que des numéros, personne ne se sent « table 12 ».',
  },
];

export const FAQ = [
  {
    q: 'Le plan de table en ligne est-il vraiment gratuit ?',
    a: 'Oui. RSVP Please est entièrement gratuit, sans publicité et sans carte bancaire : plan de table, liste d’invités, réponses, budget et rétroplanning.',
  },
  {
    q: 'Faut-il créer un compte ?',
    a: 'Oui, un compte gratuit, pour que votre plan soit enregistré et que vous puissiez le modifier à deux. La création prend deux minutes.',
  },
  {
    q: 'Dois-je saisir mes invités à la main ?',
    a: 'Non. Vous pouvez importer votre liste depuis un fichier Excel ou CSV. Vos invités répondent ensuite en ligne et leurs réponses apparaissent sur le plan.',
  },
  {
    q: 'Puis-je faire un plan de table sur mon téléphone ?',
    a: 'Oui. Sur téléphone, touchez un invité puis une place libre pour l’y asseoir. Sur ordinateur, glissez-déposez.',
  },
  {
    q: 'Comment transmettre le plan au traiteur ?',
    a: 'Passez en vue traiteur : chaque place affiche le menu choisi, les enfants et les allergies. Imprimez ensuite le plan et la liste table par table.',
  },
  {
    q: 'Quelles formes de tables sont possibles ?',
    a: 'Des tables rondes et rectangulaires, de 2 à 24 places, que vous pouvez nommer, déplacer et faire pivoter.',
  },
  {
    q: 'Combien d’invités par table pour un mariage ?',
    a: 'En général 8 à 10 invités sur une table ronde de 150 cm, 10 à 12 sur une table de 180 cm. Votre lieu de réception vous indiquera les tables disponibles.',
  },
];
